import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("reliable-testimonials", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("reliable-testimonial")
      ) {
        return {
          type: "reliable-testimonials",
        };
      }
    },
    model: {
      defaults: {
        components: html`
          <section id="testimonial" class="bg-contain">
            <div class="container mx-auto py-6 px-4 md:px-12">
              <div class="flex items-center md:gap-x-40 gap-x-4 p">
                <div>
                  <div class="flex items-center leading-2.5 gap-1">
                    <div
                      class="bg-amber-600 w-1 md:h-12 h-6 inline-block"
                    ></div>
                    <h3
                      class="md:text-4xl text-xl font-bold font-roboto tracking-normal text-white"
                    >
                      Testimonals
                    </h3>
                  </div>
                  <p
                    class="font-roboto text-white text-xs md:text-lg mt-2 w-full md:text-nowrap"
                  >
                    What Clients Say About Us
                  </p>
                </div>
                <div class="swiper mySwiper">
                  <div class="swiper-wrapper my-10">
                    <div
                      class=" box-border md:py-8 py-4 rounded-lg px-3 md:px-5 bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] swiper-slide  "
                    >
                      <div class="flex flex-col items-center justify-center">
                        <div class="grid place-items-center ">
                          <div class="flex gap-x-1 justify-center py-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                          </div>
                        </div>

                        <div
                          class="flex items-center gap-x-4 md:gap-x-12 md:w-[80%] w-full  "
                        >
                          <div class="w-10 h-10 md:w-20 md:h-14 ">
                            <img class=" w-full h-full object-cover" />
                          </div>

                          <p
                            class="md:text-xl text-sm text-[#0083D7] w-full font-roboto  font-semibold"
                          >
                            Sugun Pant
                          </p>
                        </div>

                        <div class="relative">
                          <div
                            class="flex justify-between items-center md:absolute md:-top-4 md:-right-1 md:-left-1 w-full"
                          >
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 42 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7382)">
                                <path
                                  d="M39.7197 0.624041C39.7197 1.2316 39.7679 1.74064 39.6978 2.23216C39.6682 2.44125 39.4241 2.66567 39.2238 2.79156C38.2528 3.40788 37.1986 3.9005 36.2933 4.60768C33.3638 6.8978 31.6276 9.91262 31.5324 13.8295C31.5061 14.9406 31.9155 15.2198 32.8482 14.7852C35.5445 13.535 38.4444 14.2685 39.9912 16.5914C41.6781 19.1268 41.4406 22.5028 39.4187 24.7163C36.8373 27.5429 32.5877 27.6282 29.6572 24.9265C27.9023 23.3085 27.0682 21.2198 26.8602 18.8432C26.1629 10.8836 30.1553 4.32196 37.423 1.4396C38.1422 1.15497 38.879 0.920706 39.7197 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7382)">
                                <path
                                  d="M24.3939 0.624041C24.3939 1.2316 24.4421 1.74064 24.372 2.23216C24.3424 2.44125 24.0983 2.66567 23.898 2.79156C22.927 3.40788 21.8728 3.9005 20.9675 4.60768C18.038 6.8978 16.3018 9.91262 16.2066 13.8295C16.1803 14.9406 16.5897 15.2198 17.5224 14.7852C20.2187 13.535 23.1186 14.2685 24.6654 16.5914C26.3523 19.1268 26.1148 22.5028 24.0928 24.7163C21.5115 27.5429 17.2619 27.6282 14.3314 24.9265C12.5765 23.3085 11.7424 21.2198 11.5344 18.8432C10.8371 10.8836 14.8294 4.32196 22.0972 1.4396C22.8164 1.15497 23.5532 0.920706 24.3939 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 41.61 26.3838)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 26.2843 26.3838)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 43 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7387)">
                                <path
                                  d="M2.50028 26.897C2.50028 26.2894 2.45211 25.7804 2.52217 25.2888C2.55173 25.0797 2.79585 24.8553 2.99618 24.7294C3.96718 24.1131 5.02138 23.6205 5.9267 22.9133C8.85614 20.6232 10.5923 17.6084 10.6876 13.6915C10.7139 12.5804 10.3044 12.3012 9.37174 12.7358C6.67548 13.986 3.77561 13.2525 2.22879 10.9296C0.541848 8.39424 0.779399 5.01817 2.80132 2.80467C5.38264 -0.021858 9.63228 -0.107245 12.5628 2.59449C14.3176 4.21246 15.1518 6.30116 15.3598 8.67777C16.0571 16.6374 12.0647 23.199 4.79697 26.0814C4.07775 26.366 3.34101 26.6003 2.50028 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7387)">
                                <path
                                  d="M17.8264 26.897C17.8264 26.2894 17.7783 25.7804 17.8483 25.2888C17.8779 25.0797 18.122 24.8553 18.3223 24.7294C19.2934 24.1131 20.3476 23.6205 21.2529 22.9133C24.1823 20.6232 25.9185 17.6084 26.0138 13.6915C26.04 12.5804 25.6306 12.3012 24.6979 12.7358C22.0017 13.986 19.1018 13.2525 17.555 10.9296C15.868 8.39424 16.1056 5.01817 18.1275 2.80467C20.7088 -0.021858 24.9585 -0.107245 27.889 2.59449C29.6438 4.21246 30.478 6.30116 30.686 8.67777C31.3833 16.6374 27.3909 23.199 20.1231 26.0814C19.4039 26.366 18.6672 26.6003 17.8264 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(0.609985 0.11084)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(15.9358 0.11084)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>

                          <p
                            class="md:p-5 md:mb-15 text-[10px] md:text-xl font-semibold w-full font-roboto text-[#272727] tracking-wide text-center"
                          >
                            Exception international cargo courier service! Loved
                            it's serviceand customer care. Swift, reliable, and
                            hassle-free. Highly recommended for all shipping
                            needs.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class=" box-border md:py-8 py-4 rounded-lg px-3 md:px-5 bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] swiper-slide  "
                    >
                      <div class="flex flex-col items-center justify-center">
                        <div class="grid place-items-center ">
                          <div class="flex gap-x-1 justify-center py-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                          </div>
                        </div>

                        <div
                          class="flex items-center gap-x-4 md:gap-x-12 md:w-[80%] w-full  "
                        >
                          <div class="w-10 h-10 md:w-20 md:h-14 ">
                            <img class=" w-full h-full object-cover" />
                          </div>
                          <p
                            class="md:text-xl text-sm text-[#0083D7] w-full font-roboto  font-semibold"
                          >
                            Ranju Acharya
                          </p>
                        </div>

                        <div class="relative">
                          <div
                            class="flex justify-between items-center md:absolute md:-top-4 md:-right-1 md:-left-1 w-full"
                          >
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 42 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7382)">
                                <path
                                  d="M39.7197 0.624041C39.7197 1.2316 39.7679 1.74064 39.6978 2.23216C39.6682 2.44125 39.4241 2.66567 39.2238 2.79156C38.2528 3.40788 37.1986 3.9005 36.2933 4.60768C33.3638 6.8978 31.6276 9.91262 31.5324 13.8295C31.5061 14.9406 31.9155 15.2198 32.8482 14.7852C35.5445 13.535 38.4444 14.2685 39.9912 16.5914C41.6781 19.1268 41.4406 22.5028 39.4187 24.7163C36.8373 27.5429 32.5877 27.6282 29.6572 24.9265C27.9023 23.3085 27.0682 21.2198 26.8602 18.8432C26.1629 10.8836 30.1553 4.32196 37.423 1.4396C38.1422 1.15497 38.879 0.920706 39.7197 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7382)">
                                <path
                                  d="M24.3939 0.624041C24.3939 1.2316 24.4421 1.74064 24.372 2.23216C24.3424 2.44125 24.0983 2.66567 23.898 2.79156C22.927 3.40788 21.8728 3.9005 20.9675 4.60768C18.038 6.8978 16.3018 9.91262 16.2066 13.8295C16.1803 14.9406 16.5897 15.2198 17.5224 14.7852C20.2187 13.535 23.1186 14.2685 24.6654 16.5914C26.3523 19.1268 26.1148 22.5028 24.0928 24.7163C21.5115 27.5429 17.2619 27.6282 14.3314 24.9265C12.5765 23.3085 11.7424 21.2198 11.5344 18.8432C10.8371 10.8836 14.8294 4.32196 22.0972 1.4396C22.8164 1.15497 23.5532 0.920706 24.3939 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 41.61 26.3838)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 26.2843 26.3838)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 43 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7387)">
                                <path
                                  d="M2.50028 26.897C2.50028 26.2894 2.45211 25.7804 2.52217 25.2888C2.55173 25.0797 2.79585 24.8553 2.99618 24.7294C3.96718 24.1131 5.02138 23.6205 5.9267 22.9133C8.85614 20.6232 10.5923 17.6084 10.6876 13.6915C10.7139 12.5804 10.3044 12.3012 9.37174 12.7358C6.67548 13.986 3.77561 13.2525 2.22879 10.9296C0.541848 8.39424 0.779399 5.01817 2.80132 2.80467C5.38264 -0.021858 9.63228 -0.107245 12.5628 2.59449C14.3176 4.21246 15.1518 6.30116 15.3598 8.67777C16.0571 16.6374 12.0647 23.199 4.79697 26.0814C4.07775 26.366 3.34101 26.6003 2.50028 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7387)">
                                <path
                                  d="M17.8264 26.897C17.8264 26.2894 17.7783 25.7804 17.8483 25.2888C17.8779 25.0797 18.122 24.8553 18.3223 24.7294C19.2934 24.1131 20.3476 23.6205 21.2529 22.9133C24.1823 20.6232 25.9185 17.6084 26.0138 13.6915C26.04 12.5804 25.6306 12.3012 24.6979 12.7358C22.0017 13.986 19.1018 13.2525 17.555 10.9296C15.868 8.39424 16.1056 5.01817 18.1275 2.80467C20.7088 -0.021858 24.9585 -0.107245 27.889 2.59449C29.6438 4.21246 30.478 6.30116 30.686 8.67777C31.3833 16.6374 27.3909 23.199 20.1231 26.0814C19.4039 26.366 18.6672 26.6003 17.8264 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(0.609985 0.11084)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(15.9358 0.11084)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>

                          <p
                            class="md:p-5 md:mb-15 text-[10px] md:text-xl font-semibold w-full font-roboto text-[#272727] tracking-wide text-center"
                          >
                            Reliable Cargo P. Ltd has been a market leader in
                            logistics, courier, freight and shipping services in
                            Nepal.Thanks for your reliable service
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class=" box-border md:py-8 py-4 rounded-lg px-3 md:px-5 bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] swiper-slide  "
                    >
                      <div class="flex flex-col items-center justify-center">
                        <div class="grid place-items-center ">
                          <div class="flex gap-x-1 justify-center py-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 43 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                                fill="#FECC2B"
                              />
                            </svg>
                          </div>
                        </div>

                        <div
                          class="flex items-center gap-x-4 md:gap-x-12 md:w-[80%] w-full  "
                        >
                          <div class="w-10 h-10 md:w-20 md:h-14">
                            <img class=" w-full h-full object-cover" />
                          </div>

                          <p
                            class="md:text-xl text-sm text-[#0083D7] w-full font-roboto  font-semibold"
                          >
                            Sweet Laxu
                          </p>
                        </div>

                        <div class="relative">
                          <div
                            class="flex justify-between items-center md:absolute md:-top-4 md:-right-1 md:-left-1 w-full"
                          >
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 42 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7382)">
                                <path
                                  d="M39.7197 0.624041C39.7197 1.2316 39.7679 1.74064 39.6978 2.23216C39.6682 2.44125 39.4241 2.66567 39.2238 2.79156C38.2528 3.40788 37.1986 3.9005 36.2933 4.60768C33.3638 6.8978 31.6276 9.91262 31.5324 13.8295C31.5061 14.9406 31.9155 15.2198 32.8482 14.7852C35.5445 13.535 38.4444 14.2685 39.9912 16.5914C41.6781 19.1268 41.4406 22.5028 39.4187 24.7163C36.8373 27.5429 32.5877 27.6282 29.6572 24.9265C27.9023 23.3085 27.0682 21.2198 26.8602 18.8432C26.1629 10.8836 30.1553 4.32196 37.423 1.4396C38.1422 1.15497 38.879 0.920706 39.7197 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7382)">
                                <path
                                  d="M24.3939 0.624041C24.3939 1.2316 24.4421 1.74064 24.372 2.23216C24.3424 2.44125 24.0983 2.66567 23.898 2.79156C22.927 3.40788 21.8728 3.9005 20.9675 4.60768C18.038 6.8978 16.3018 9.91262 16.2066 13.8295C16.1803 14.9406 16.5897 15.2198 17.5224 14.7852C20.2187 13.535 23.1186 14.2685 24.6654 16.5914C26.3523 19.1268 26.1148 22.5028 24.0928 24.7163C21.5115 27.5429 17.2619 27.6282 14.3314 24.9265C12.5765 23.3085 11.7424 21.2198 11.5344 18.8432C10.8371 10.8836 14.8294 4.32196 22.0972 1.4396C22.8164 1.15497 23.5532 0.920706 24.3939 0.624041Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 41.61 26.3838)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7382">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="matrix(-1 0 0 -1 26.2843 26.3838)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <svg
                              class=" md:w-12 md:h-12 w-4 h-4"
                              viewBox="0 0 43 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_271_7387)">
                                <path
                                  d="M2.50028 26.897C2.50028 26.2894 2.45211 25.7804 2.52217 25.2888C2.55173 25.0797 2.79585 24.8553 2.99618 24.7294C3.96718 24.1131 5.02138 23.6205 5.9267 22.9133C8.85614 20.6232 10.5923 17.6084 10.6876 13.6915C10.7139 12.5804 10.3044 12.3012 9.37174 12.7358C6.67548 13.986 3.77561 13.2525 2.22879 10.9296C0.541848 8.39424 0.779399 5.01817 2.80132 2.80467C5.38264 -0.021858 9.63228 -0.107245 12.5628 2.59449C14.3176 4.21246 15.1518 6.30116 15.3598 8.67777C16.0571 16.6374 12.0647 23.199 4.79697 26.0814C4.07775 26.366 3.34101 26.6003 2.50028 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <g clip-path="url(#clip1_271_7387)">
                                <path
                                  d="M17.8264 26.897C17.8264 26.2894 17.7783 25.7804 17.8483 25.2888C17.8779 25.0797 18.122 24.8553 18.3223 24.7294C19.2934 24.1131 20.3476 23.6205 21.2529 22.9133C24.1823 20.6232 25.9185 17.6084 26.0138 13.6915C26.04 12.5804 25.6306 12.3012 24.6979 12.7358C22.0017 13.986 19.1018 13.2525 17.555 10.9296C15.868 8.39424 16.1056 5.01817 18.1275 2.80467C20.7088 -0.021858 24.9585 -0.107245 27.889 2.59449C29.6438 4.21246 30.478 6.30116 30.686 8.67777C31.3833 16.6374 27.3909 23.199 20.1231 26.0814C19.4039 26.366 18.6672 26.6003 17.8264 26.897Z"
                                  fill="#DCDCDC"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(0.609985 0.11084)"
                                  />
                                </clipPath>
                                <clipPath id="clip1_271_7387">
                                  <rect
                                    width="26.2729"
                                    height="26.2729"
                                    fill="white"
                                    transform="translate(15.9358 0.11084)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>

                          <p
                            class="md:p-5 md:mb-15 text-[10px] md:text-xl font-semibold w-full font-roboto text-[#272727] tracking-wide text-center"
                          >
                            Best courier service, reasonable charges, and a good
                            purchase. Good communication and fast delivery.
                            Thanks you so much for deliverying my purchase
                            safely.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </section>
        `,

        script: function () {
          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".mySwiper", {
              direction: "horizontal",
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true,
              autoplay: true,
              breakpoints: {
                640: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          };
          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
